import React from "react";
import { Terminal } from "lucide-react";

const SectionHeader = ({ tag, title, highlight, subtitle, align = "left" }) => {
	return (
		<div className={`section-header ${align === "center" ? "text-center" : ""}`} style={{ marginBottom: "40px", textAlign: align }}>
			{tag && (
				<div className="section-tag" style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
					<Terminal size={14} />
					<span>{tag}</span>
				</div>
			)}
			<h2 className="title" style={{ fontSize: "2.25rem", width: "100%", margin: "8px 0" }}>
				{title} {highlight && <span className="gradient-text">{highlight}</span>}
			</h2>
			{subtitle && <p className="subtitle" style={{ width: "100%", margin: "12px 0 0 0", maxWidth: "700px" }}>{subtitle}</p>}
		</div>
	);
};

export default SectionHeader;
